module.exports = {"TXTWCL_Bet_ID":{"id":"TXTWCL_Bet_ID","defaultMessage":"Bet ID"}}